import React, { useContext } from 'react'
import {
    SponsoredLogoContainer,
    StyledWestLiveStickyBanner,
    StyledWestLiveBranding,
    StyledWestLiveLogo,
    StyledPresenterImage,
    StyledPlayerWrapper,
} from './TheWestLiveStickyBanner.styled'
import { IsHydrating } from '@news-mono/web-common'
import { TheWestLivePlayer } from '../../../content/TheWestLive/TheWestLivePlayer/TheWestLivePlayer'
import { TheWestLivePlayerSkin } from '../TheWestLivePlayer/TheWestLivePlayerSkin/TheWestLivePlayerSkin'
import { useOnAirState, TheWestLiveContext } from '../TheWestLiveProvider'
import { themedValue } from '../../../__styling/themed-value'
import { useTheme } from '@emotion/react'
import { PlayerSponsorship } from '../../../content/TheWestLive/LivePlayer/Sponsorship/Sponsorship'
import { toRadioEvent } from '@news-mono/web-common'
import { DataLayerEventName } from '@news-mono/web-common'

const benImage = require('./assets/ben-oshea@1x.png')
const benImage2x = require('./assets/ben-oshea@2x.png')

export interface TheWestLiveStickyBannerProps {
    showSponsorLogo?: boolean
}

/* Should be lazy loaded, and only imported directly for tests */
export const TheWestLiveStickyBanner: React.FC<TheWestLiveStickyBannerProps> = ({
    showSponsorLogo,
}) => {
    const isHydrating = React.useContext(IsHydrating)
    const { playerState, setPlayerState, onEvent } = useContext(
        TheWestLiveContext,
    )
    const { onAir, broadcast } = useOnAirState()
    const theme = useTheme()

    if (isHydrating || !onAir) {
        return null
    }

    const linkTo = themedValue(theme, {
        thewest: '/the-west-live',
        fallback: 'https://thewest.com.au/the-west-live',
    })

    function handleControlClick() {
        setPlayerState({
            ...playerState,
            state: playerState.state === 'stopped' ? 'loading' : 'stopped',
        })

        onEvent(
            toRadioEvent(
                playerState.state === 'stopped'
                    ? DataLayerEventName.radioPlay
                    : DataLayerEventName.radioStop,
                broadcast,
                'player',
            ),
        )
    }

    return (
        // js-ts-ignore - where ts equals TruSkin
        // This class exists so that TruSkin wont wrap the banner
        <StyledWestLiveStickyBanner className="js-ts-ignore">
            <StyledWestLiveBranding to={linkTo}>
                <StyledPresenterImage
                    srcSet={`${benImage}, ${benImage2x} 2x`}
                    src={benImage}
                    alt=""
                />
                <StyledWestLiveLogo />
            </StyledWestLiveBranding>
            <StyledPlayerWrapper>
                <TheWestLivePlayer
                    PlayerSkin={(props) => (
                        <TheWestLivePlayerSkin
                            {...props}
                            onControlClick={handleControlClick}
                        />
                    )}
                />
            </StyledPlayerWrapper>
            {showSponsorLogo && (
                <SponsoredLogoContainer>
                    <PlayerSponsorship />
                </SponsoredLogoContainer>
            )}
        </StyledWestLiveStickyBanner>
    )
}
TheWestLiveStickyBanner.displayName = 'TheWestLiveStickyBanner'

export default TheWestLiveStickyBanner
